/* src/app/modules/spare-parts/amount-consumed-graph/amount-consumed-graph.component.scss */
:host {
  display: block;
}
#graph {
  width: 100%;
  height: 220px;
}
/*# sourceMappingURL=amount-consumed-graph.component.css.map */
